import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { fromStaticDataBusinessGroupsActions } from '../actions';
import { IStaticDataResponse } from '../models/static-data.model';

export const staticDataBusinessGroupsFeatureKey = 'staticDataBusinessGroups';

export interface StaticDataBusinessGroupsState {
  loadStaticDataBusinessGroups: void;
  loadStaticDataBusinessGroupsResponse: IStaticDataResponse[];
  loadStaticDataBusinessGroupsFailure: IGenericError<ErrorResponse>;
}

export const initialState: StaticDataBusinessGroupsState = {
  loadStaticDataBusinessGroups: undefined,
  loadStaticDataBusinessGroupsResponse: undefined,
  loadStaticDataBusinessGroupsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromStaticDataBusinessGroupsActions.loadStaticDataBusinessGroups, (state, action) => ({
    ...state,
    loadStaticDataBusinessGroups: null
  })),

  on(fromStaticDataBusinessGroupsActions.loadStaticDataBusinessGroupsSuccess, (state, action) => ({
    ...state,
    loadStaticBusinessGroupsResponse: action.response
  })),

  on(fromStaticDataBusinessGroupsActions.loadStaticDataBusinessGroupsFailure, (state, action) => ({
    ...state,
    loadResendOtpFailure: action.error
  }))
);

export const getStaticDataBusinessGroupsResponse = (state: StaticDataBusinessGroupsState) => state.loadStaticDataBusinessGroupsResponse;
export const getStaticDataBusinessGroupsFailure = (state: StaticDataBusinessGroupsState) => state.loadStaticDataBusinessGroupsFailure;
